import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Switch } from '@headlessui/react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const EditServiceForm = (props) => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const selectedService = props.selectedService;
  const [serviceEnabled, setServiceEnabled ] = useState(selectedService.status === "enabled" ? true : false) 
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [service, setService] = useState(null);
  const user = useSelector((state) => state.auth.user);

  const handleSetServiceProviderEnabled = () => {
    setServiceEnabled(!serviceEnabled);
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    const serviceName = event.target.name.value;
    const serviceDescription = event.target.description.value;
    const serviceTags = event.target.tags.value.split(" ");
    const servicePrice = event.target.price.value;    
    //const serviceImage = "https://media.istockphoto.com/id/2060766764/vector/77.jpg?s=612x612&w=0&k=20&c=chKGOTPlfbntQjzdUTu26SiYYOoSmBwfD4wOXff8z_4=";

    const newService = {
      id: selectedService.id,
      name: serviceName,
      description: serviceDescription,
      tags: serviceTags,
      price: servicePrice,
      status: serviceEnabled ? "enabled" : "disabled",
      image_url: selectedService.image_url,
      provider_id: selectedService.provider_id
    };
    setService(newService);
    setFormSubmitted(true);
  };

  useEffect(() => {
    if (formSubmitted && service) {
      fetch(`${process.env.REACT_APP_SERVICE_API_URL}/update-service`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Api-Name': 'service-api',
          },
          body: JSON.stringify(service),
        })
          .then(response => response.json())
          .then(data => console.log(data))
          .catch(error => console.error(error));

        props.onServiceUpdate(service);
        props.setShowEditServiceFormPopup(false);
    }
    }, [formSubmitted, service]);

    //props.onServiceUpdate(service);
    // navigate(props.navigate);
    //props.setShowEditServiceFormPopup(false);
  

  return (
    <div className="">
      <h1 className="text-left mtl-5 text-pri-dark text-sm md:text-xl mb-5"><strong>Edit Service Details</strong></h1>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <div className="container rounded-3xl flex flex-row  gap-4 relative max-w-sm md:max-w-3xl">
          <h1 className="text-xl md:text-xl text-pri-dark">Enable Service</h1>
          <Switch
            checked={serviceEnabled}
            onChange={handleSetServiceProviderEnabled}
            className={classNames(
              'bg-pri-yellow relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-pri-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-pri-dark focus:ring-offset-2'
            )}
          >
            <span
              aria-hidden="true"
              className={classNames(
                serviceEnabled ? 'translate-x-5' : 'translate-x-0',
                'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-pri-dark shadow ring-0 transition duration-200 ease-in-out'
              )}
            />
          </Switch>
        </div> 
        <div className="">
            <p className="text-left text-pri-dark text-xl p-1"><strong>Title</strong></p>
            <input
              id="name"
              name="name"
              value={service?.name || selectedService.name}
              type="text"
              autoComplete="name"
              maxLength={30}
              required
              className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
              placeholder="Title *"
              onChange={(event) => {
                const newName = event.target.value;
                setService((prevService) => ({
                  ...prevService,
                  name: newName
                }));
              }}
            />
            <p className="text-right text-pri-dark text-xs p-1"><strong>30</strong> characters max</p>
        </div>
        <div className="">
          <p className="text-left text-pri-dark text-xl p-1"><strong>Description</strong></p>
          <textarea
            id="description"
            name="description"
            value={service?.description || selectedService.description}
            autoComplete="description"
            required
            onChange={(event) => {
              const newDesc = event.target.value;
              setService((prevService) => ({
                ...prevService,
                description: newDesc
              }));
            }}
            maxLength={200}
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Description *"
          />
          <p className="text-right text-pri-dark text-xs p-1"><strong>200</strong> characters max</p>
        </div>
        <div className="">
        <p className="text-left text-pri-dark text-xl p-1"><strong>Tags</strong></p>
          <textarea
            id="tags"
            name="tags"
            value={service?.tags || selectedService.tags.join(' ')}
            type="text"
            autoComplete="tags"
            required
            onChange={(event) => {
              const newTags = event.target.value;
              setService((prevService) => ({
                ...prevService,
                tags: newTags
              }));
            }}
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Tag(s) (for multiple leave space) *"
          />
        </div>
        <div className="">
          <p className="text-left text-pri-dark text-xl p-1"><strong>Price (£)</strong></p>
          <input
            id="price"
            name="price"
            value={`${service?.price || selectedService.price}`}
            type="text"
            autoComplete="price"
            required
            onChange={(event) => {
              const newPrice = event.target.value;
              setService((prevService) => ({
                ...prevService,
                price: newPrice
              }));
            }}
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Price (£)*"
          />
        </div>
        <button type="submit" className="p-2 bg-pri-dark text-sec-white rounded-full mt-2">
          Submit
        </button>
      </form>
    </div>
  );
}

export default EditServiceForm;